<style lang="less" scoped>
    .main-container {
        width: 100%;
        height: 100%;
        background: #EAECF3;
        .left-logo-menu-div {
            // width: 329px;
            height: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            background: #ffffff;
            margin-right: 2px;
            // background-image: url('../assets/main/left-bg.png');
            // background-size: 100% 100%;
            display: flex;
            flex-direction: column;
            .pro-title-div {
                // margin-top: 30px;
                // margin-bottom: 16px;
                .left-close-icon {
                    height: 75px;
                    width: 75px;
                    box-sizing: border-box;
                    margin-left: 30px;
                    // font-size: 18px;
                    // color: #364166;
                    // cursor: pointer;
                }
                .right-title-div {
                    margin-left: 15px;
                    height: 75px;
                    line-height: 75px;
                    font-size: 26px;
                    font-weight: 600;
                    color: #364166;

                }
            }
        }
        .left-small-menu-div {
            width: 121px;
            background-image: url('../assets/main/left-small-menu-bg.png');
            .menu-collpose-div {
                margin-top: 24px;
                height: 56px;
                display: flex;
                align-items: center;
                cursor: pointer;
                margin-left: 26px;
            }
        }
        .left-logo-menu-div::-webkit-scrollbar {
            width: 0;
        }
        .right-bar-content-div {
            overflow-y: auto;
            .header-container-user {
                // margin-left: 50px;
                text-align: right;
                height: 75px;
                background: #fff;
                line-height: 75px;
                padding-right: 50px;
                .flex-x-end {
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: flex;
                    
                    -webkit-box-orient: horizontal;
                    -webkit-flex-direction: row;
                    flex-direction: row;

                    -webkit-box-pack: flex-end;
                    -webkit-justify-content: flex-end;
                    -ms-flex-pack: flex-end;
                    justify-content: flex-end;
                }
                .align-center {
                    -webkit-box-align: center;
                    -webkit-align-items: center;
                    -ms-flex-align: center;
                    -ms-grid-row-align: center;
                    align-items: center;
                }
                .header-container-img {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    overflow: hidden;
                    margin-right: 30px;
                    img {
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }
                .user-icon-container {
                    width: 35px;
                    height: 35px;
                    padding: 3px 4px 0 0 ;
                    border-radius: 50%;
                    background-color: #4182EB;
                    overflow: hidden;
                    i {
                        font-size: 26px;
                        line-height: 26px;
                        color: #ffffff;
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }
                .header-container-name {
                    font-size: 16px;
                    color: #919191;
                    margin: 0 10px;
                }
                .header-container-down {
                    width: 0;
                    height: 0;
                    border-left: 4px solid transparent;
                    border-right: 4px solid transparent;
                    border-top: 4px solid #919191;
                }
            }
            // .left-settings-div {
            //     display: flex;
            //     flex-direction: row;
            //     justify-content: right;
            //     height: 75px;
            //     line-height: 75px;
            //     background: #fff;
            //     margin-left: -45px;
            //     // margin: 32px 20px;
            //     .user-info-div {
            //         // margin-bottom: 16px;
            //         .left-user-icon-div{
            //             width: 25px;
            //             height: 25px;
            //         }
            //         .right-title-div {
            //             font-size: 16px;
            //             font-weight: 400;
            //             color: #364166;
            //             line-height: 75px;
            //             margin-left: 40px;
            //         }
            //     }
            //     .setting-child-div {
            //         .left-icon-div {
            //             width: 40px;
            //             height: 32px;
            //             display: flex;
            //             justify-content: center;
            //             align-items: center;
            //         }
            //         .right-title-div {
            //             font-size: 14px;
            //             font-weight: 400;
            //             color: #364166;
            //             line-height: 75px;
            //             margin-left: 40px;
            //             cursor: pointer;
            //         }
            //     }
            // }
            .action-btns-div {
                width: 100%;
                height: 64px;
                background: rgba(62, 174, 232, 1);
                border: 0;
                .user-logout-div {
                    margin-right: 32px;
                    cursor: pointer;
                    .user-icon-div {
                        margin-right: 8px;
                    }
                    .down-icon-div {
                        margin-left: 8px;
                    }
                    .user-name-div {
                        font-size: 14px;
                        color: #fff;
                    }
                }
            }
            .center-line-div {
                width: 100%;
                height: 1px;
                background: #51B8EE;
            }
            .bread-crumb-div {
                width: 100%;
                height: 64px;
                background: rgba(62, 174, 232, 1);
            }
            .content-view-div {
                margin: 0 0 0 30px;
                width:calc(100%-30px) ;
                height:calc(100%-85px)  ;
            }
        }
    }
</style>

<template>
    <div class="main-container flex">
        <div class="left-logo-menu-div">
            <div class="pro-title-div flex">
                <div class="left-close-icon" @click="updateMenuCollposed">
                    <img src="../assets/main/logo.png"  width="100%" height="100%">
                    <!-- <i class="el-icon-close"></i> -->
                </div>
                <div class="right-title-div">挚达</div>
            </div>
            <div class="menu-div flex-1">
                <Menu></Menu>
            </div>

        </div>
        <div class="right-bar-content-div flex-1">
            <div class="header-container-user flex-grow-0 c-pointer">
                <el-dropdown class="header-dropdown" @command="handleCommand">
                    <div class="flex-x-end align-center">
                        <div class="header-container-img">
                            <img src="../assets/main/notice.png" />
                        </div>
                        <div class="user-icon-container">
                            <i class="el-icon-s-custom"></i>
                        </div>
                        <p class="header-container-name">{{ userName }}</p>
                        <i class="header-container-down"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="01">密码修改</el-dropdown-item>
                        <el-dropdown-item command="02" divided>退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <!-- <div class="bread-crumb-div">
                        <bread-crumb></bread-crumb>
                    </div> -->
            <div class="content-view-div">
                <router-view></router-view>
            </div>
            <!-- 密码重置 -->
            <el-dialog title="密码重置" width="520px" :visible.sync="popup.show">
                <el-form :model="popup.formInfo" ref="pwdResetRef" :rules="popup.rules">
                    <el-form-item label="输入密码" prop="restPassWord">
                        <el-input clearable v-model="popup.formInfo.restPassWord" type="password" size="small" />
                    </el-form-item>
                    <el-form-item label="确认密码" prop="checknewPassWord">
                        <el-input clearable v-model="popup.formInfo.checknewPassWord" type="password" size="small"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cancel" size="small">取 消</el-button>
                    <el-button type="primary" @click="submitPwdFrom('pwdResetRef')" size="small">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import Menu from '@/components/menu/index.vue';
    export default {
        components: {
            Menu
        },
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '' || value === undefined) {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.popup.formInfo.restPassWord) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                menuCollposed: false,
                userName: '',
                popup:{
                    formInfo:{

                    },
                    show:false,
                    rules: {
                        restPassWord: [
                          {
                            required: true,
                            message: '请输入新密码',
                            trigger: 'blur'
                          },
                          {
                            required: true,
                            message: "请输入8位及以上包含大小写字母、数字、特殊字符",
                            trigger: "blur",
                            pattern: /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F])[\da-zA-Z\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]{8,}$/, // 与app端同步的客户密码正则
                          }
                        ],
                        checknewPassWord: [
                          {
                            required: true,
                            validator: validatePass,
                            trigger: 'blur'
                          },
                          {
                            required: true,
                            message: "请输入8位及以上包含大小写字母、数字、特殊字符",
                            trigger: "blur",
                            pattern: /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F])[\da-zA-Z\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]{8,}$/, // 与app端同步的客户密码正则
                          }
                        ],
                    },
                },
            }
        },
        methods: {
            init() {
                this.userName = this.$store.state.userInfo.userName
            },
            /* 修改密码 && 退出登录 */
            handleCommand(val) {
                if (val == '01') {
                    this.popup.formInfo = {
                        restPassWord: '',
                        checknewPassWord: ''
                    }
                    this.popup.show = true
                } else if (val == '02') {
                    this.logoutFun()
                }
            },
            cancel(){
                this.popup.show = false
                this.popup.formInfo = {}
            },
            //密码提交
            submitPwdFrom(formName) {
                let _ = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var obj = {
                            restPassWord: _.popup.formInfo.restPassWord,
                            userId: _.$store.state.userInfo.userId
                        }
                        _.$H.post(_, _.$A.user.userPwdReset, obj).then(res => {
                            _.$U.success('修改成功')
                            _.popup.show = false;
                            _.logoutFun()
                        })
                    }
                });
            },
            logoutFun() {
                this.$store.commit('setToken', '');
                this.$store.commit("updateCurMenuListList", []);
                this.$router.replace('/');
            },
            updateMenuCollposed(){
                // this.menuCollposed = !this.menuCollposed;
                // this.$store.commit('setMenuCollapse',this.menuCollposed);
                this.$router.push({
                    name:'mainMenu'
                })
            }
        },
        mounted() {
            this.init();
        },
        computed: {
            getUserName() {
                return this.$store.state.userInfo.userName;
            }
        }
    }
</script>
